// maintain isomorphic properties (allow server rendering by mocking localStorage)
const mockStore: Record<string, string | undefined> = {}
export const LocalStorage = typeof localStorage !== 'undefined' ? localStorage : {
    getItem: ( key: string ) => mockStore[ key ],
    setItem: ( key: string, value: string ) => mockStore[ key ] = value,
    removeItem: ( key: string ) => mockStore[ key ] = undefined
}
